"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require("./components/Dialog/index"));
var index_1 = require("./components/Dialog/index");
exports.default = index_1.Dialog;

//# sourceMappingURL=Dialog.js.map



//////////////////
// WEBPACK FOOTER
// ../Dialog.js
// module id = 161
// module chunks = 0